
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import './App.css'
import routeCollection from './routes/routes';
import NotFound from './pages/notefound/NotFound';


function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        {routeCollection.map((route, index) => {
          if (route.children) {
            return (
              <Route
                key={index}
                path={route.path}
                element={route.element}
              >
                {route.children.map((childRoute, childIndex) => (
                  <Route
                    key={childIndex}
                    path={childRoute.path}
                    element={childRoute.element}
                  />
                ))}
              </Route>
            );
          }
          return (
            <Route
              key={index}
              path={route.path}
              element={route.element}
            />
          );
        })}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}

export default App
